module.exports = __webpack_public_path__ + "static/media/like.020ce180.svg";